/**
 * TemplateButton Component
 * Button to open the template browser modal
 */

import { forwardRef } from 'react';
import './templates.css';

/**
 * Props for TemplateButton component
 */
export interface TemplateButtonProps {
  /** Click handler to open template browser */
  onClick: () => void;
}

/**
 * TemplateButton component
 * Renders a button that opens the template browser
 */
export const TemplateButton = forwardRef<HTMLButtonElement, TemplateButtonProps>(
  ({ onClick }, ref) => {
    return (
      <button
        ref={ref}
        onClick={onClick}
        className="template-button"
        aria-label="Browse composition templates"
        title="Browse Templates"
      >
        <span className="template-icon" aria-hidden="true">
          📋
        </span>
        <span className="template-label">Templates</span>
      </button>
    );
  }
);

TemplateButton.displayName = 'TemplateButton';
